export default "__VITE_ASSET__af4aa727__"